<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="col-12 shadow-btm row">
          <div class="col-lg-6 col-sm-6 my-auto">
            <h4 class="mb-0 lg-bld">Manage News</h4>
          </div>
          <div class="col-6 d-flex justify-content-end">
            <div class="" v-show="accessObject?.is_add == 1">
              <a
                style="padding-left: 20px; padding-right: 20px; cursor: pointer"
                v-on:click="$router.push('/add-news')"
                class="add-btn"
                >Add</a
              >
            </div>
            <div class="ml-2" v-if="$helperService.canExportAndPdf(role)">
              <a
                v-on:click="getNewsExport()"
                style="cursor: pointer"
                class="add-btn"
                >Export</a
              >
            </div>
            <!-- <div class="ml-2">
              <a
                v-on:click="showImportPopup()"
                style="cursor: pointer"
                class="add-btn"
                >Import</a
              > -->
              <a href="javascript:void(0)" 
                @click="openOffcanvas" 
                class="add-btn ml-2 px-3 w-auto py-1" 
                style="height:28px" 
                v-if="$helperService.canExportAndPdf(role)"
                >
                Send Email
              </a>
              <a href="javascript:void(0)" 
                @click="downloadPdf" 
                class="add-btn ml-2 px-3 w-auto py-1" 
                style="height:28px"
                v-if="$helperService.canExportAndPdf(role)"
                >
                Download PDF
              </a>
              <a href="javascript:void(0)" 
                @click="downloadHtml" 
                class="add-btn ml-2 px-3 w-auto py-1" 
                style="height:28px"
                v-if="$helperService.canExportAndPdf(role)"
                >
                <span v-if="downloadHtmlLoading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                <span v-if="!downloadHtmlLoading">Download HTML</span>
                <span v-else>Downloading...</span>
              </a>
          </div>
        </div>
        <div class="page-content">
          <div class="card-body py-0 px-0">
            <div class="px-0">
              <div class="row">
                <div class="col-lg-12 col-sm-12">
                  <!-- <form class="form-search form-inline"> -->
                  <Field
                    name="keyword"
                    type="text"
                    class="form-control"
                    v-on:keyup.enter="getList(0)"
                    placeholder="Search"
                    v-model="searchObj.keyword"
                    style="border: 0px none; width: 100%"
                  />
                  <!-- </form> -->
                </div>
              </div>
              <hr class="mt-0 mb-2" />
            </div>
            <div class="row">

              <!-- News Type Dropdown  -->
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">News Type</label>
                <Multiselect
                  mode="single"
                  trackBy="lable"
                  label="value"
                  valueProp="lable"
                  v-model="searchObj.type"
                  :options="types"
                  searchable="true"
                  placeholder="Select"
                />
              </div>

              <!-- Company Dropdown  -->
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">Company</label>
                <Multiselect
                  mode="single"
                  trackBy="company_name"
                  label="company_name"
                  valueProp="id"
                  placeholder="Select"
                  v-model="searchObj.company_id"
                  :options="companyList"
                  searchable="true"
                  v-on:change="geteComponydetail($event)"
                  @search-change="searchCompanyName($event)"
                />
              </div>

              <!-- Industry Dropdown -->
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">Industry</label>
                <Multiselect
                  mode="single"
                  trackBy="industry_name"
                  label="industry_name"
                  valueProp="id"
                  v-model="searchObj.industry_id"
                  :options="industryList"
                  searchable="true"
                  placeholder="Select"
                  @search-change="searchIndustryName($event)"
                  @change="industryChange($event)"
                />
              </div>

              <!-- Subsector Dropdown  -->
              <div class="col-lg-2 col-sm-4 col-6" v-if="showSubsectorDropdown">
                <label class="label">Subsector</label>
                <Multiselect
                  mode="single"
                  trackBy="industry_name"
                  label="industry_name"
                  valueProp="id"
                  v-model="searchObj.subsector_id"
                  :options="subsectorsList"
                  searchable="true"
                  placeholder="Select"
                />
              </div>

              <!-- Location Dropdown  -->
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">Location</label>
                <Multiselect
                  mode="single"
                  trackBy="country_name"
                  label="country_name"
                  valueProp="id"
                  v-model="searchObj.country_id"
                  :options="cityList"
                  searchable="true"
                  placeholder="Select"
                  @search-change="searchCityName($event)"
                />
              </div>

              <!-- Job Function Dropdown  -->
              <div class="col-lg-2 col-sm-4 col-6" v-if="!showSubsectorDropdown">
                <label class="label">Job Function</label>
                <Multiselect
                  mode="single"
                  trackBy="job_function_name"
                  label="job_function_name"
                  valueProp="id"
                  v-model="searchObj.job_function_id_new"
                  :options="jobFunctionList"
                  searchable="true"
                  placeholder="Select"
                  @search-change="searchJobFunctionName($event)"
                />
              </div>

              <!-- Apply & Reset button -->
              <div class="col-lg-2 col-sm-4 col-6">
                <label></label>
                <button
                  type="button"
                  style="margin-top: 23px; width: 50%"
                  v-on:click="getList(0)"
                  @click="showHeadingPopup()"
                  class="apply-btn mr-1"
                >
                  Apply
                </button>
                <button
                  v-on:click="resetFilter()"
                  type="button"
                  style="margin-top: 23px; width: 40%"
                  class="apply-btn"
                >
                  Reset
                </button>
                <div class="text-center">
                  <a
                    style="cursor: pointer"
                    v-on:click="getAdvanceSearch()"
                    class="advance-search"
                    >{{ is_show ? "Hide Advance Search" : "Advance Search" }}</a
                  >
                </div>
                <!--  <div class="text-center"><a href="#" class="advance-search">Advance Search</a></div> -->
              </div>

            </div>
            <div v-show="is_show" class="row advasearch-data mt-1">

              <!-- Job Function Dropdown  -->
              <div class="col-lg-2 col-sm-4 col-6" v-if="showSubsectorDropdown">
                <label class="label">Job Function</label>
                <Multiselect
                  mode="single"
                  trackBy="job_function_name"
                  label="job_function_name"
                  valueProp="id"
                  v-model="searchObj.job_function_id_new"
                  :options="jobFunctionList"
                  searchable="true"
                  placeholder="Select"
                  @search-change="searchJobFunctionName($event)"
                />
              </div>

              <!-- Region Dropdown  -->
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">Region</label>
                <Multiselect
                  mode="single"
                  trackBy="region_name"
                  label="region_name"
                  valueProp="id"
                  placeholder="Select"
                  v-model="searchObj.region_id_new"
                  :options="regionList"
                  searchable="true"
                  @search-change="searchRegionName($event)"
                />
              </div>

              <!-- From Date Dropdown  -->
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">From Date</label>
                <datepicker
                  v-model="searchObj.from_date"
                  inputFormat="dd/MM/yyyy"
                  placeholder="From Date"
                  class="form-control"
                  style="background-color: white !important; border: black;"
                  :clearable="false"
                  :upperLimit="searchObj.to_date ? searchObj.to_date : new Date()"
                  v-on:click="searchObj.date_period = ''"
                >
                </datepicker>
              </div>

              <!-- To Date Dropdown -->
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">To Date</label>
                <datepicker
                  v-model="searchObj.to_date"
                  inputFormat="dd/MM/yyyy"
                  class="form-control"
                  placeholder="To Date"
                  :clearable="false"
                  style="background-color: white !important;"
                  :lowerLimit="searchObj.from_date ? searchObj.from_date : null"
                  :upperLimit="new Date()"
                  v-on:click="searchObj.date_period = ''"
                >
                </datepicker>
              </div>
              
              <!-- Date period Dropdown -->
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">Date period</label>
                <div class="form-group mb-3">
                  <Multiselect
                    mode="single"
                    trackBy="value"
                    label="value"
                    valueProp="id"
                    v-model="searchObj.date_period"
                    :options="date_periods"
                    searchable="true"
                    placeholder="Select"
                    v-on:click="searchObj.from_date = ''; searchObj.to_date = ''; searchObj.start_date = ''; searchObj.end_date = ''"
                  />
                </div>
              </div>

              <!-- Past Company Dropdown  -->
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">Past Company</label>
                <Multiselect
                  mode="single"
                  trackBy="company_name"
                  label="company_name"
                  valueProp="id"
                  placeholder="Select"
                  v-model="searchObj.prev_company_id"
                  :options="companyList"
                  searchable="true"
                  @search-change="searchCompanyName($event)"
                />
              </div>

              <!-- Company Type Dropdown  -->
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">Company Type</label>
                <Multiselect
                  mode="single"
                  trackBy="value"
                  label="value"
                  valueProp="id"
                  v-model="searchObj.company_type"
                  :options="company_types"
                  searchable="true"
                  placeholder="Select"
                />
              </div>              

              <!-- Deal Stage Dropdown -->
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">Deal Stage</label>
                <Multiselect
                  mode="single"
                  trackBy="name"
                  label="name"
                  valueProp="id"
                  placeholder="Select"
                  v-model="searchObj.deal_stage_id"
                  :options="dealStageList"
                  searchable="true"
                />
              </div>

            </div>
            <hr />
            <div class="card border mb-0 radius-15">
              <div class="card-body p-0 pb-4">
                <div class="table-responsive">
                  <div class="dataTables_wrapper dt-bootstrap4">
                    <table
                      class="table table-striped table-bordered dataTable"
                      style="width: 100%"
                      role="grid"
                      aria-describedby="example_info"
                    >
                      <thead>
                        <tr role="row">
                          <th>Sr No</th>
                          <th
                            class="sorting"
                            style="min-width: 250px"
                            id="id-title"
                            v-on:click="sorting('news_title', 'id-title')"
                          >
                            News title
                          </th>
                          <th
                            class="sorting"
                            style="min-width: 180px"
                            id="id-company_name"
                            v-on:click="
                              sorting(
                                'tbl_company.company_name',
                                'id-company_name'
                              )
                            "
                          >
                            Company Name
                          </th>
                          <th
                            class="sorting"
                            style="min-width: 180px"
                            id="id-executive_name"
                            v-on:click="
                              sorting(
                                'tbl_executive.executive_name',
                                'id-executive_name'
                              )
                            "
                          >
                            Executive Name
                          </th>
                          <th
                            class="sorting"
                            style="min-width: 180px"
                            id="id-created_on"
                            v-on:click="
                              sorting(
                                'tbl_company_news.created_on',
                                'id-created_on'
                              )
                            "
                          >
                            Published Date
                          </th>
                          <th
                            class="sorting"
                            style="min-width: 250px"
                            id="id-news_link"
                            v-on:click="sorting('news_link', 'id-news_link')"
                          >
                            Url
                          </th>
                          <th
                            class="sorting"
                            style="min-width: 100px"
                            id="id-type"
                            v-on:click="sorting('type', 'id-type')"
                          >
                            Type
                          </th>
                          <th
                            v-if="
                              accessObject?.is_edit == 1 ||
                              accessObject?.is_delete == 1 ||
                              accessObject?.is_publish == 1
                            "
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody v-show="!loader">
                        <tr v-for="(data, index) in list" :key="index">
                          <td>
                            {{
                              ($refs.listPagination.currentPage - 1) * $refs.listPagination.itemsPerPage +
                              index +
                              1
                            }}
                          </td>
                          <td>
                            {{ $helperService.getText(data.news_title, 50) }}
                          </td>
                          <td>
                            {{ data.company_name ?? "-" }}
                          </td>
                          <td>
                            {{
                              data.executive_name ?? "-"
                            }}
                          </td>
                          <td>
                            {{ data.news_date }}
                          </td>
                          <td>
                            {{ $helperService.getText(data.news_link, 50) }}
                          </td>
                          <td>
                            {{ data.type }}
                          </td>
                          <td
                            v-if="
                              accessObject?.is_edit == 1 ||
                              accessObject?.is_delete == 1 ||
                              accessObject?.is_publish == 1
                            "
                          >
                            <a
                              v-if="accessObject?.is_edit == 1"
                              class="edit-btn btn-style cursor-pointer"
                              v-on:click="goToView('/edit-news/' + data.id)"
                              >Edit</a
                            >
                            <a
                              v-if="accessObject?.is_delete == 1"
                              class="delete-btn btn-style cursor-pointer"
                              v-on:click="showDeletePopup(data)"
                              >Delete</a
                            >
                            <a
                              v-show="
                                data.publish == 'Y' &&
                                accessObject?.is_publish == 1
                              "
                              class="fill-btn btn-style cursor-pointer"
                              v-on:click="updatepublishstatus('N', data.id)"
                              >Publish</a
                            >
                            <a
                              v-show="
                                data.publish == 'N' &&
                                accessObject?.is_publish == 1
                              "
                              class="fill-btn btn-style cursor-pointer"
                              v-on:click="updatepublishstatus('Y', data.id)"
                              >Unpublish</a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mx-0 mb-4">
                  <div class="col-lg-12 mt-5 text-center">
                    <div class="page-bottom-pagination text-right">
                      <Pagination
                        @page-change="pageChange"
                        @items-per-page-change="itemsPerPageChange"
                        ref="listPagination"
                      />
                    </div>
                  </div>
                </div>
                <ErrorComponent @retry="getList(0)" ref="errorComponent" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DeleteModal
      @remove="deleteRecord($event)"
      @get-list="getList(0)"
      ref="deleteItem"
    />
  </div>

  <!-- Offcanvas start -->
  <!-- Overlay for offcanvas start -->
  <div v-if="isCanvasOpen" class="offcanvas-overlay"></div>
  <!-- Overlay for offcanvas end -->   
  <div class="offcanvas" :class="{ show: isCanvasOpen }">
    <div class="offcanvas-header">
      <h5 class="mb-0">Compose Email</h5>
      <button type="button" class="close" @click="closeOffcanvas">&times;</button>
    </div>

    <div class="offcanvas-body">
      <!-- Tabs -->
      <ul class="nav nav-tabs" style="cursor: pointer;">
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: activeTab === 'email' }"
            @click="activeTab = 'email'"
          >
            Email
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: activeTab === 'preview' }"
            @click="activeTab = 'preview'"
          >
            Preview
          </a>
        </li>
      </ul>

      <!-- Tab Content -->
      <div class="tab-content mt-3">
        <!-- Email Tab -->
        <div v-show="activeTab === 'email'" style="text-align: left;">
          <form>
            <div class="form-group">
              <label>To</label>
              <input
                type="text"
                class="form-control"
                v-model="emaildetails.to"
                placeholder="Enter email or leave empty if using group"
              />
            </div>
            <div class="text-center my-2 fw-bold">— OR —</div>
            <div class="form-group">
              <label class="label">Group Name</label>
              <Multiselect
                v-model="emaildetails.email_group_id"
                :options="group_name_list"
                label="name"
                valueProp="id"
                trackBy="name"
                mode="single"
                searchable="true"
                placeholder="Select"
              />
            </div>
            <div class="form-group">
              <label class="mb-0">Subject</label>
              <input
                type="text"
                class="form-control"
                v-model="emaildetails.subject"
              />
            </div>
            <!-- <div class="form-group">
              <label class="mb-0">Body</label>
              <textarea
                rows="10"
                class="form-control"
                v-model="emaildetails.body"
              ></textarea>
            </div> -->
          </form>
        </div>

        <!-- Preview Tab -->
        <!-- <div v-show="activeTab === 'preview'">
          <div v-if="isPreviewLoading" style="text-align:center; padding:40px;">
            <img src="/img/loader.gif" alt="Loading..." style="height:48px;" />
          </div>
          <div v-else v-html="emaildetails.body" style="background-color: #f9f9f9; padding: 10px; min-height: 200px;">
          </div>
        </div> -->

        <!-- Preview Tab -->
        <div v-show="activeTab === 'preview'" style="min-height: 200px;">
          <iframe
            v-if="!isPreviewLoading"
            :srcdoc="emaildetails.body"
            style="width: 100%; height: 80vh; border: none; overflow: auto;"
            sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-forms allow-scripts allow-top-navigation-by-user-activation"
          ></iframe>
          <div v-else style="text-align:center; padding:40px;">
            <img src="/img/loader.gif" alt="Loading..." style="height:48px;" />
          </div>
        </div>

      </div>

      <!-- Footer -->
      <div v-show="activeTab === 'email'" class="text-center mt-3">
        <button type="submit" class="fill-btn w-auto px-4" @click="sendEmail" :disabled="sendLoading">
          <span v-if="sendLoading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
          <span v-if="!sendLoading">Send</span>
          <span v-else>Sending...</span>
        </button>&nbsp;
        <button type="button" class="fill-btn w-auto px-4" @click="closeOffcanvas">
          Cancel
        </button>
      </div>
    </div>
  </div>
  <!-- Offcanvas end -->

  <!-- Template Heading Modal -->
  <TextModal ref="textModal">
    <!-- <Form ref="practiceForm" @submit="uploadDocument()"> -->
    <div class="modal-header">
      <h5 class="modal-title">Heading</h5>
      <button
        type="button"
        class="close"
        v-on:click="$refs.textModal.closeModal">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="col-lg-12 col-sm-12 mb-3">
        <div class="text-center mb-4">
            <div class="input-group mb-3">
              <input
                type="text"
                class="form-control"
                v-model="searchObj.template_heading"
                placeholder="Enter Template Heading"
                required
              />
            </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        id="cancle-button"
        class="btn btn-secondary position-relative w-auto px-4"
        data-dismiss="modal"
        v-on:click="$refs.textModal.closeModal">
        Cancel
      </button>
      <button
        v-on:click="$refs.textModal.closeModal"
        id="document-button"
        type="button"
        class="btn btn-primary position-relative w-auto mt-0 mb-0 px-4">
        Submit
      </button>
    </div>

    <!-- </Form> -->
  </TextModal>  
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import DeleteModal from "@/components/DeleteModal";
import Pagination from "@/components/Pagination";
import datepicker from "vue3-datepicker";
import Multiselect from "@vueform/multiselect";
import moment from "moment";
import { Field } from "vee-validate";
import TextModal from "@/components/TextModal";

export default {
  name: "Package Group",
  components: {
    ErrorComponent,
    TextModal,
    DeleteModal,
    datepicker,
    Multiselect,
    Pagination,
    Field,
  },
  data() {
    return {
      accessObject: this.$helperService.getAccessLevel("Manage News"),
      loader: true,
      isPreviewLoading: false,
      downloadHtmlLoading: false,
      role: localStorage.getItem("role"),
      offset: -1,
      list: [],
      sendLoading: false,
      is_show: false,
      isCanvasOpen: false,
      isDownloadHtml: false, // Flag to indicate HTML download
      showSubsectorDropdown: false,
      activeTab: "email",
      group_name_list: [],
      emaildetails: {
        to: "",
        email_group_id: "",
        subject: "",
        body: "",
        type: "NEWS",
        filter_criteria : "" // The request data will be stored inside this
      },
      company_types: [
        "Public",
        "Private",
        "Education",
        "Government",
        "Not-for-Profit",
        "Venture Funded",
        "PE Backed",
      ],
      date_periods: [
        "Last Month",
        "Last 3 Month",
        "Last 6 Month",
        "Last 1 Year",
      ],
      types: [
        {
          value: "Arrival / Departure",
          lable: "arrival_departure",
        },
        {
          value: "Internal Move",
          lable: "internal_move",
        },
        {
          value: "Lay Off",
          lable: "lay_off",
        },
        {
          value: "Own Venture",
          lable: "own_venture",
        },
        {
          value: "Terminated",
          lable: "terminated",
        },
      ],
      searchObj: {
        type: [],
        from_date: "",
        to_date: "",
        country_id: "",
        company_type: "",
        job_function_id_new: "",
        prev_company_id: "",
        region_id_new: "",
        deal_stage_id: "",
        date_period: "",
        industry_id: [],
        company_id: [],
        response_type: "",
        subsector_id: "",
        template_heading: ""
      },
      industryList: [],
      companyList: [],
      company_ids: [],
      cityList: [],
      regionList: [],
      jobFunctionList: [],
      dealStageList: [],
      subsectorsList: [],
      cityKeyword: "",
      companyKeyword: "",
      industryKeyword: "",
      newsTypeKeyword: "",
      jobFunctionKeyword: "",
      regionKeyword: "",
    };
  },
  mounted() {
    this.getList(0);
    this.getDynamicHeading();
    this.companylist();
    this.CityList();
    this.jobFunctionlist();
    this.getRegionlist();
    this.getindustrylist();
    this.groupNameList();
    this.getDealStageList();
  },
  methods: {
    getAdvanceSearch() {
      this.is_show = !this.is_show;
    },
    searchCityName(e) {
      this.cityKeyword = e;
      this.CityList();
    },
    searchRegionName(e) {
      this.regionKeyword = e;
      this.getRegionlist();
    },
    searchJobFunctionName(e) {
      this.jobFunctionKeyword = e;
      this.jobFunctionlist();
    },
    searchNewsType(e) {
      this.newsTypeKeyword = e;
      this.getindustrylist();
    },
    searchIndustryName(e) {
      this.industryKeyword = e;
      this.getindustrylist();
    },
    searchCompanyName(e) {
      this.companyKeyword = e;
      this.companylist();
    },
    showHeadingPopup() {
      this.searchObj.template_heading = "";
      this.getDynamicHeading();
      this.$refs.textModal.showModal();
    },
    getDynamicHeading() {
      this.$api
        .getAPI({
          _action: "/news/dynamic-heading",
          _body: this.searchObj,
        })
        .then((res) => {
          this.searchObj.template_heading = res;
        })
        .catch(() => {});
    },
    openOffcanvas() {
      this.activeTab = "email";
      this.isCanvasOpen = true;
      this.isPreviewLoading = true;
      // this.searchObj.response_type = "preview_html";
      this.getList(0, null, null, 'preview_html');
    },
    downloadHtml() {
      // this.searchObj.response_type = "download_html";
      this.downloadHtmlLoading = true;
      this.isDownloadHtml = true; // mark that we want to download
      this.getList(0, null, null, 'download_html'); // this will trigger getHtml()
    },
    downloadHtmlFile(content) {
      const blob = new Blob([content], { type: "text/html" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "news.html";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    },
    closeOffcanvas() {
      this.isCanvasOpen = false;
      this.searchObj.response_type = "";
      this.emaildetails.to = "";
      this.emaildetails.email_group_id = "";
      this.emaildetails.subject = "";
      this.emaildetails.body = "";
      this.emaildetails.type = "NEWS"
      this.emaildetails.filter_criteria = "";
    },
    companylist() {
      var obj = {};
      if (this.companyKeyword) {
        obj.keyword = this.companyKeyword;
      }
      if (this.company_ids) {
        obj.company_ids = this.company_ids;
      }
      this.$api
        .getAPI({
          _action: "/company/list",
          _body: obj,
        })
        .then((res) => {
          this.companyList = res;
        })
        .catch(() => {});
    },
    geteComponydetail(id) {
      if (id) {
        this.$api
          .getAPI({
            _action: "/company/detail/" + id,
          })

          .then((res) => {
            this.searchObj.industry_id = res.industry_id;
            if (this.searchObj.industry_id) {
              this.getSubsectorList(this.searchObj.industry_id);
              this.searchObj.subsector_id = res.subsector_id;
            }
          })
          .catch(() => {});
      }
    },
    industryChange(e) {
      if (e) {
        this.getSubsectorList(e);
      } else {
        this.searchObj.subsector_id = "";
        this.showSubsectorDropdown = false;
      }
    },
    getSubsectorList(id) {
      this.$api
        .getAPI({
          _action: "/subsectors/list/" + id,
        })
        .then((res) => {
          this.subsectorsList = res.list;
          
          if (this.subsectorsList.length > 0) {
            this.showSubsectorDropdown = true;
          } else {
            this.searchObj.subsector_id = "";
            this.showSubsectorDropdown = false;
          }
        })
        .catch(() => { });
    },    
    getDealStageList() {
      this.$api
        .getAPI({
          _action: "/deal/stage/list",
        })
        .then((res) => {
          this.dealStageList = res;
        })
        .catch(() => {});
    },

    getindustrylist() {
      var obj = {};
      if (this.industryKeyword) {
        obj.keyword = this.industryKeyword;
      }      
      this.$api
        .getAPI({
          _action: "/industry/list",
          _body: obj,
        })
        .then((res) => {
          this.industryList = res;
        })
        .catch(() => {});
    },
    getRegionlist() {
      var obj = {};
      if (this.regionKeyword) {
        obj.keyword = this.regionKeyword;
      }
      this.$api
        .getAPI({
          _action: "/region/list",
          _body: obj,
        })
        .then((res) => {
          this.regionList = res;
        })
        .catch(() => {});
    },

    jobFunctionlist() {
      var obj = {};
      if (this.jobFunctionKeyword) {
        obj.keyword = this.jobFunctionKeyword;
      }
      this.$api
        .getAPI({
          _action: "/job/function/list",
        })
        .then((res) => {
          this.jobFunctionList = res;
        })
        .catch(() => {});
    },
    groupNameList() {
      this.$api
        .getAPI({
          _action: "/email_group/list_nopagination",
        })
        .then((res) => {
          this.group_name_list = res;
        })
        .catch(() => {});
    },
    sendEmail() {
      // Validation: Either 'to' OR 'email_group_id' must be filled
      if (!this.emaildetails.to && !this.emaildetails.email_group_id) {      
        this.$notify({
            type: "error",
            text: "Please enter a recipient email or select a group.",
          });
        return;
      }
      if (this.emaildetails.to && this.emaildetails.email_group_id) {
        this.$notify({
            type: "error",
            text: "Please fill only one: 'To' OR 'Group'.",
          });
        return;
      }
      this.sendLoading = true;
      this.$api
        .postAPI({
          _action: "/email_logs/add",
          _body: this.emaildetails,
        })
        .then((res) => {
          this.sendLoading = false;
          this.$notify({
            type: "success",
            text: res.message,
          });
          
          this.closeOffcanvas();
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, " ");
          }
        })
        .catch(() => {
          this.sendLoading = false;
        });
    },    
    CityList() {
      var obj = {};
      if (this.cityKeyword) {
        obj.keyword = this.cityKeyword;
      }
      this.$api
        .getAPI({
          _action: "/country/list",
          _body: obj,
        })
        .then((res) => {
          this.cityList = res;
        })
        .catch(() => {});
    },
    resetFilter() {
      this.searchObj = {};
      this.searchObj.type = "";
      this.searchObj.from_date = "";
      this.searchObj.to_date = "";
      this.searchObj.industry_id = "";
      this.searchObj.company_id = "";
      this.searchObj.country_id = "";
      this.searchObj.company_type = "";
      this.searchObj.job_function_id_new = "";
      this.searchObj.region_id_new = "";
      this.response_type = "";
      this.emaildetails.to = "";
      this.emaildetails.email_group_id = "";
      this.emaildetails.subject = "";
      this.emaildetails.body = "";
      this.emaildetails.type = "NEWS"
      this.emaildetails.filter_criteria = "";
      this.searchObj.subsector_id = "";
      this.showSubsectorDropdown= false;
      this.getDynamicHeading();
      this.getList(0);
    },
    santiseValueSearch() {
      if (this.searchObj.from_date) {
        this.searchObj.start_date = moment(this.searchObj.from_date).format(
          "DD-MM-YYYY"
        );
      }
      if (this.searchObj.to_date) {
        this.searchObj.end_date = moment(this.searchObj.to_date).format(
          "DD-MM-YYYY"
        );
      }
      if (!this.searchObj.job_function_id_new) {
        this.searchObj.job_function_id_new = "";
      }
      if (!this.searchObj.region_id_new) {
        this.searchObj.region_id_new = "";
      }
      if (!this.searchObj.country_id) {
        this.searchObj.country_id = "";
      }
      if (!this.searchObj.company_type) {
        this.searchObj.company_type = "";
      }
      if (!this.searchObj.keyword) {
        this.searchObj.keyword = "";
      }
      if (!this.searchObj.industry_id) {
        this.searchObj.industry_id = "";
      }
      if (!this.searchObj.subsector_id) {
        this.searchObj.subsector_id = "";
      }      
      if (!this.searchObj.company_id) {
        this.searchObj.company_id = "";
      }
      if (!this.searchObj.prev_company_id) {
        this.searchObj.prev_company_id = "";
      }
      if (!this.searchObj.deal_stage_id) {
        this.searchObj.deal_stage_id = "";
      }
      if (!this.searchObj.date_period) {
        this.searchObj.date_period = "";
      }
      if (!this.searchObj.template_heading) {
        this.searchObj.template_heading = "";
      }
      if (!this.searchObj.type) {
        this.searchObj.type = "";
      }
      if (!this.searchObj.prev_company_id) {
        this.searchObj.prev_company_id = "";
      }
     
    },
    updatepublishstatus(status, id) {
      var obj = {};
      obj.id = id;
      obj.publish = status;
      this.$api
        .putAPI({
          _action: "/news",
          _body: obj,
        })
        .then(() => {
          this.getList(0);
        })
        .catch(() => {});
    },
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    goToView(url) {
      this.searchObj.is_show = this.is_show;
      this.$shareService.setMapValue("news_page_filter", this.searchObj);
      this.$router.push(url);
    },
    getNewsExport() {
      var obj = {};
      if (this.searchObj.from_date) {
        obj.from_date = moment(this.searchObj.from_date).format("DD-MM-YYYY");
      } else {
        obj.from_date = "";
      }

      if (this.searchObj.to_date) {
        obj.to_date = moment(this.searchObj.to_date).format("DD-MM-YYYY");
      } else {
        obj.to_date = "";
      }

      if (this.searchObj.keyword) {
        obj.keyword = this.searchObj.keyword;
      } else {
        obj.keyword = "";
      }

      if (this.searchObj.country_id) {
        obj.country_id = this.searchObj.country_id;
      } else {
        obj.country_id = "";
      }
      if (this.searchObj.company_type) {
        obj.company_type = this.searchObj.company_type;
      } else {
        obj.company_type = "";
      }

      if (this.searchObj.job_function_id_new) {
        obj.job_function_id_new = this.searchObj.job_function_id_new;
      } else {
        obj.job_function_id_new = "";
      }
      if (this.searchObj.prev_company_id) {
        obj.prev_company_id = this.searchObj.prev_company_id;
      } else {
        obj.prev_company_id = "";
      }

      if (this.searchObj.type) {
        obj.type = this.searchObj.type;
      } else {
        obj.type = "";
      }

      if (this.searchObj.region_id_new) {
        obj.region_id_new = this.searchObj.region_id_new;
      } else {
        obj.region_id_new = "";
      }
      if (this.searchObj.industry_id) {
        obj.industry_id = this.searchObj.industry_id;
      } else {
        obj.industry_id = "";
      }
      if (this.searchObj.subsector_id) {
        obj.subsector_id = this.searchObj.subsector_id;
      } else {
        obj.subsector_id = "";
      }
      if (this.searchObj.deal_stage_id) {
        obj.deal_stage_id = this.searchObj.deal_stage_id;
      } else {
        obj.deal_stage_id = "";
      }
      if (this.searchObj.date_period) {
        obj.date_period = this.searchObj.date_period;
      } else {
        obj.date_period = "";
      }
      if (this.searchObj.company_id) {
        obj.company_id = this.searchObj.company_id;
      } else {
        obj.company_id = "";
      }

      if (this.searchObj.limit) {
        obj.limit = this.searchObj.limit;
      } else {
        obj.limit = "";
      }
      // var url = this.$api.getBaseUrl() + "/company/export/data";

      var url =
        this.$api.getBaseUrl() +
        "/news/export/data?keyword=" +
        obj.keyword +
        "&start_date=" +
        obj.from_date +
        "&end_date=" +
        obj.to_date +
        "&country_id=" +
        obj.country_id +
        "&company_type=" +
        obj.company_type +
        "&job_function_id_new=" +
        obj.job_function_id_new +
        "&prev_company_id=" +
        obj.prev_company_id +
        "&region_id_new=" +
        obj.region_id_new +
        "&industry_id=" +
        obj.industry_id +
        "&company_id=" +
        obj.company_id +
        "&subsector_id=" +
        obj.subsector_id +
        "&deal_stage_id=" +
        obj.deal_stage_id +
        "&date_period=" +
        obj.date_period +
        "&limit=" +
        obj.limit +
        "&type=" +
        obj.type;
      // alert(url);
      // console.log("Fd",url)
      window.open(url);
    },
    getList(page, orderBy, sortBy, response_type) {  // Developer Note: If you change the getNewsList then you should also change the getHtml because We are sending in email all list data as a newslatter.     
      if (response_type) {
        this.searchObj.response_type = response_type;
        this.getHtml(page, orderBy, sortBy, response_type);
      } else {
        this.searchObj.response_type = "";
        this.getNewsList(page, orderBy, sortBy);
      }
    },
    getNewsList(page, orderBy, sortBy) {      
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      this.santiseValueSearch();
      if (this.offset != page) {
        this.searchObj.offset = page;
      } else {
        this.searchObj.offset = page;
      }
      var filter_obj = this.$shareService.getMapValue("news_page_filter")
        ? this.$shareService.getMapValue("news_page_filter")
        : null;
      if (filter_obj) {
        this.searchObj = filter_obj;
        this.is_show = this.searchObj.is_show;
        this.$shareService.getMapValueAndRemove("news_page_filter");
        if (this.searchObj.company_id) {
          this.company_ids.push(this.searchObj.company_id);
          this.companylist();
        }
      }
      this.$api
        .getAPI({
          _action: "/news/pagination/listv2",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;         
          this.list = res.list;
          this.offset = res.next_offset;
          this.accessObject = this.$helperService.getAccessLevel("Manage News");
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
                this.$refs.listPagination.setCurrentPage(
                  this.searchObj.offset + 1
                );
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "No news list available");
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
    sorting(sortBy, id) {
      var obj = this.$helperService.sorting(sortBy, id);
      this.getList(0, obj.order_by, obj.sort_by);
    },
    showDeletePopup(data) {
      this.$refs.deleteItem.showModal(
        "Delete News",
        "Are you sure you want to delete",
        data
      );
    },
    deleteRecord(dataObj) {
      var detail = new Proxy(dataObj, {});
      this.$refs.deleteItem.deleteRecord("/news/" + detail.id);
    },
    getHtml(page, orderBy, sortBy) {
      // this.$refs.errorComponent.updateListLoader(true);
      // this.list = [];
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      if (this.searchObj.from_date) {
        this.searchObj.start_date = moment(this.searchObj.from_date).format(
          "DD-MM-YYYY"
        );
      }
      if (this.searchObj.to_date) {
        this.searchObj.end_date = moment(this.searchObj.to_date).format(
          "DD-MM-YYYY"
        );
      }
      if (!this.searchObj.job_function_id_new) {
        this.searchObj.job_function_id_new = "";
      }
      if (!this.searchObj.region_id_new) {
        this.searchObj.region_id_new = "";
      }
      if (!this.searchObj.country_id) {
        this.searchObj.country_id = "";
      }
      if (!this.searchObj.company_type) {
        this.searchObj.company_type = "";
      }
      if (!this.searchObj.keyword) {
        this.searchObj.keyword = "";
      }
      if (!this.searchObj.industry_id) {
        this.searchObj.industry_id = "";
      }
      if (!this.searchObj.company_id) {
        this.searchObj.company_id = "";
      }
      if (this.offset != page) {
        this.searchObj.offset = page;
      } else {
        this.searchObj.offset = page;
      }
      var filter_obj = this.$shareService.getMapValue("news_page_filter")
        ? this.$shareService.getMapValue("news_page_filter")
        : null;
      if (filter_obj) {
        this.searchObj = filter_obj;
        this.is_show = this.searchObj.is_show;
        this.$shareService.getMapValueAndRemove("news_page_filter");
        if (this.searchObj.company_id) {
          this.company_ids.push(this.searchObj.company_id);
          this.companylist();
        }
      }

      this.emaildetails.filter_criteria = JSON.parse(JSON.stringify(this.searchObj));
      
      this.$api
        .getAPI({
          _action: "/news/pagination/listv2",
          _body: this.searchObj,
        })
        .then((res) => {
          this.isPreviewLoading = false;
          this.downloadHtmlLoading = false;
          if (this.isDownloadHtml) {
            this.downloadHtmlFile(res.result);
            this.isDownloadHtml = false; // reset the flag
          } else {
            this.emaildetails.body = res.result;
          }
          // this.loader = false;
          // this.list = res.list;
          // this.offset = res.next_offset;
          // this.accessObject = this.$helperService.getAccessLevel("Manage News");
          // if (page == 0) {
          //   if (this.$refs.listPagination) {
          //     if (res.count != null && res.count > 0) {
          //       this.$refs.listPagination.setTotalCount(res.count);
          //       this.$refs.listPagination.setCurrentPage(
          //         this.searchObj.offset + 1
          //       );
          //     } else {
          //       this.$refs.listPagination.setTotalCount(0);
          //     }
          //   }
          // }
          // if (this.$refs.errorComponent) {
          //   this.$refs.errorComponent.setData(res, "No news list available");
          //   this.$refs.errorComponent.updateListLoader(false);
          // }
        })
        .catch(() => {
          this.isPreviewLoading = false;
          this.downloadHtmlLoading = false;
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
    downloadPdf(orderBy, sortBy, page) {
      console.log('news-', orderBy, sortBy, page);
      this.searchObj.order_by = "";
      this.searchObj.sort_by = "";
      this.searchObj.offset = "";
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      this.santiseValueSearch();
      // if (this.offset != page) {
      //   this.searchObj.offset = page;
      // } else {
      //   this.searchObj.offset = page;
      // }

      this.$api
        .getAPI({
          _action: "/news/downloadable-url",
          _body: this.searchObj,
        })
        .then((res) => {
          if (res && res.downloadable_url) {            
            window.open(res.downloadable_url, "_blank");
          } else {
            this.$notify({
              type: "error",
              text: "PDF generation failed. Please try again.",
            });
          }
        })
        .catch(() => {
          this.$notify({
            type: "error",
            text: "PDF generation failed. Please try again.",
          });
        });
    }
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.multiselect {
  background: #f0f0f0;
  height: 35px;
  border: 1px solid;
}

.multiselect-tag {
  background: #9cc338 !important;
}
.offcanvas {
  position: fixed;
  top: 0;
  right: -100%;
  width: 75%;
  max-width: 100%;
  height: 100%;
  background: #fff;
  transition: right 0.3s ease-in-out;
  z-index: 1050;
  overflow-y: auto;
}
.offcanvas.show {
  right: 0;
}
.offcanvas-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #ddd;
}
.offcanvas-body {
  padding: 1rem;
}
.close {
  background: none;
  border: none;
  font-size: 1.5rem;
}
.offcanvas-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1049;
}

</style>
